import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';
import axiosw from 'axios'

let basePath = config.basePath;

let getCSPageDate = (userData) => {
    return new Promise((resolve, reject) => {
        axios.post(basePath + 'costestimate/getcspagedata', userData).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}

let getCSPageDatePdf = (districtId, userId, tokenCS, academicyear,selectedyear) => {
    let csPdfObj = {
        headers: {
            'Content-Type': 'application/json',
            'authorization': tokenCS
        }
    }
    return new Promise((resolve, reject) => {
        axiosw.post(config.basePath + 'costestimate/getcspagedata', { districtId: districtId, userId: userId, academicyear: academicyear, selectedyear:selectedyear}, csPdfObj).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}

let saveCSPageData = (csData) => {
    return new Promise((resolve, reject) => {
        axios.post(basePath + 'costestimate/submitcspagedata', csData).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}

const costEstimateService = {
    getCSPageDate,
    getCSPageDatePdf,
    saveCSPageData
}

export default costEstimateService 